<template>
  <div class="footer">
    <div class="footer-box">
      <div class="logo-box">
        <!-- <img src="../assets/logo-1.png" class="logo-1" /> -->
        <div class="logo-1">
          CréditoÁgil
        </div>
        <div class="title">Contáctenos</div>
        <div class="text">
          Si está interesado en invertir con nosotros o necesita ayuda, no dude en contactarnos. Esperamos que a través de nuestros esfuerzos podamos ayudar a más personas a conseguir un futuro mejor.
        </div>
      </div>
      <div class="connect">
        <div class="title">
          Address
        </div>
        <!-- <p><img src="../assets/tel.png" alt="" /> 00852-39622878</p> -->
        <p><img src="../assets/email.png" alt="" />pt@ptjasindocitramaju.com</p>
        <p>
          <img src="../assets/address.png" alt="" />Cl. 31, Soacha, Cundinamarca, Colombia
        </p>
      </div>
      <!-- <div class="menu-box">
        <div class="title">
          Quick Links
        </div>
        <div class="br"></div>
        <div class="list">
          <p @click="selectMenu(1)">> Home</p>
          <p @click="selectMenu(2)">> Company Profile</p>
          <p @click="selectMenu(3)">> Privacy Policy</p>
          <p @click="selectMenu(5)">> Hubungi kami</p>
        </div>
      </div> -->
      <div class="send-box">
        <div class="title">
          Suscríbete a nosotros
        </div>
        <p>
          Suscríbase a nuestras últimas actualizaciones, participe en nuestras últimas consultas y explore los últimos proyectos financieros.
        </p>
        <input class="email" type="text" placeholder="Email mu" />
        <img class="btn" @click="send()" src="../assets/email.png" alt="" />
      </div>
    </div>

    <div class="copyright">
      <p>Copyright © CréditoÁgil</p>
      <div class="menu-box">
        <div :class="step == 1 ? 'select' : ''" @click="selectMenu(1)">Introducción</div>
        <div :class="step == 2 ? 'select' : ''" @click="selectMenu(2)">
          Confianza
        </div>
  
        <!-- <div :class="step == 2 ? 'select' : ''" @click="selectMenu(2)">核心業務</div> -->
        <div :class="step == 3 ? 'select' : ''" @click="selectMenu(3)">
          Privacidad
        </div>
        <div :class="step == 4 ? 'select' : ''" @click="selectMenu(4)">Objetivo</div>
        <div :class="step == 5 ? 'select' : ''" @click="selectMenu(5)">
          Contáctenos
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
.footer {
  .footer-box {
    height: 220px;
    background: #1f1f1f;
    padding: 120px 360px 106px 360px;
    display: flex;
    justify-content: space-between;
    .br {
      width: 60px;
      height: 2px;
      background-color: #504f4f;
      margin: 24px 0;
    }
    .logo-box {
      width: 400px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #fff;
      .title {
        font-size: 20px;
        font-family: Inter, Inter;
        font-weight: normal;
        color: #ffffff;
        line-height: 24px;
        margin: 16px 0;
      }
      .logo-1 {
        width: 190px;
        height: 50px;
        line-height: 50px;
        font-weight: bold;
        font-size: 23px;
      }
      .text {
      }
    }
    .connect {
      font-size: 14px;
      font-family: Roboto, Roboto;
      font-weight: 400;
      color: #ffffff;
      line-height: 16px;
      margin-top: 10px;
      .br {
        height: 1px;
      }
      .title {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        margin-bottom: 20px;
      }
      p {
        max-width: 300px;
        margin-bottom: 24px;
        img {
          width: 20px;
          margin-right: 10px;
          vertical-align: middle;
          /* height: 20px; */
        }
      }
    }
    .menu-box {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #fff;
      margin-top: 10px;
      .br {
        height: 1px;
      }
      .title {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
      }
      .list {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 150px;
        p {
          cursor: pointer;
        }
      }
    }
    .send-box {
      margin-top: 10px;
      position: relative;
      .br {
        height: 1px;
      }
      p {
        font-size: 14px;
        font-family: Inter, Inter;
        font-weight: 400;
        color: #ffffff;
        line-height: 16px;
        max-width: 330px;
      }
      .title {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        margin-bottom: 20px;
      }
    }
    .email {
      background: #151414;
      border: 1px solid #fff;
      padding: 0 20px;
      width: 190px;
      font-size: 16px;
      color: #cccccc;
      height: 56px;
      margin-top: 38px;
      padding-right: 100px;
    }
    input[type="text"]:focus {
      outline: none;
    }
    .btn {
      position: absolute;
      right: 25px;
      top: 140px;
      width: 40px;
    }
    .customer {
      width: 120px;
      font-size: 18px;
      font-weight: 500;
      color: #ffffff;
    }
  }
  .copyright {
    height: 80px;
    background: #f2f2f2;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 360px;
    p {
      font-size: 14px;
      text-align: center;
      font-family: Inter, Inter;
      font-weight: 400;
      color: #959595;
      line-height: 80px;
    }
    .menu-box {
      display: flex;
      padding: 16px 0px;
      width: 650px;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      font-family: Inter, Inter;
      font-weight: 500;
      color: #1e1e1e;
      cursor: pointer;
    }
  }
}
</style>
<script>
export default {
  props: {
    step: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      index: 0,
    };
  },
  methods: {
    send() {
      alert("kirim sukses");
    },
    selectMenu(value) {
      this.index = value;
      if (value == this.step) {
        return;
      }
      
      switch (value) {
        case 1:
          this.$router.push({ path: "/" });
          window.scrollTo(0, 0)
          break;
        case 2:
          this.$router.push({ path: "business" });
          window.scrollTo(0, 0)
          break;
        case 3:
          this.$router.push({ path: "privacy" });
          window.scrollTo(0, 0)
          break;
        case 4:
          this.$router.push({ path: "offers" });
          window.scrollTo(0, 0)
          break;
        case 5:
          this.$router.push({ path: "aboutUs" });
          window.scrollTo(0, 0)
          break;
        // case 5: this.$router.push({ path: "cooperate" }); break;
        default:
          this.$router.push({ path: "/" });
          break;
      }
    },
  },
};
</script>
